import { useMemo, useState } from 'react';

import { CostsSelectionFormStep } from '../../CostUsage/steps/Selection';
import { CostsUsageFormStep } from '../../CostUsage/steps/Usage';
import { CostsOrderFormStep } from '../../CostUsage/steps/Order';

import { MaterialFormTab } from '../enums/tab.enum';
import { MaterialInfoFormStep } from '../steps/Info';

interface Params {
  readonly stepIdsSubset?: readonly MaterialFormTab[];
}

export const useMaterialSteps = ({ stepIdsSubset }: Readonly<Params>) => {
  const [isUsingCosts, setIsUsingCosts] = useState(false);

  const { steps, wizardChildren } = useMemo(() => {
    const materialInfo = {
      step: {
        id: MaterialFormTab.MaterialInfo,
        title: 'Informations Matériel',
        isEnabled: true,
      },
      child: (
        <MaterialInfoFormStep
          id={MaterialFormTab.MaterialInfo}
          key={MaterialFormTab.MaterialInfo}
        />
      ),
    };

    const costsSelection = {
      step: {
        id: MaterialFormTab.CostsSelection,
        title: 'Liaison aux Coûts',
        isEnabled: true,
      },
      child: (
        <CostsSelectionFormStep
          id={MaterialFormTab.CostsSelection}
          key={MaterialFormTab.CostsSelection}
          setIsUsingCosts={setIsUsingCosts}
        />
      ),
    };

    const costsOrder = {
      step: {
        id: MaterialFormTab.CostsOrder,
        title: 'Ordre des Coûts',
        isEnabled: isUsingCosts,
      },
      child: (
        <CostsOrderFormStep
          id={MaterialFormTab.CostsOrder}
          key={MaterialFormTab.CostsOrder}
        />
      ),
    };

    const costsUsage = {
      step: {
        id: MaterialFormTab.CostsUsage,
        title: 'Paramétrage des Coûts',
        isEnabled: isUsingCosts,
      },
      child: (
        <CostsUsageFormStep
          id={MaterialFormTab.CostsUsage}
          key={MaterialFormTab.CostsUsage}
        />
      ),
    };

    const allTabs = [
      [MaterialFormTab.MaterialInfo, materialInfo],
      [MaterialFormTab.CostsSelection, costsSelection],
      [MaterialFormTab.CostsOrder, costsOrder],
      [MaterialFormTab.CostsUsage, costsUsage],
    ] as const;

    const activeTabs = stepIdsSubset?.length
      ? allTabs.filter(([tab]) => stepIdsSubset.includes(tab))
      : allTabs;

    const steps = activeTabs.map(([, { step }]) => step);
    const wizardChildren = activeTabs.map(([, { child }]) => child);

    return { steps, wizardChildren };
  }, [isUsingCosts, stepIdsSubset]);

  return { steps, wizardChildren };
};
